import axios from 'axios';
import { BASE_URL } from '..';


export const NftImagesApi = {
    Counts: async () => {
        const url = `${BASE_URL}/api/images-count`
        try {
            const response = await axios.get(url);
            return response.data
        } catch (error) {
            // Handle network errors
            console.log('Error', 'An error occurred. Please try again later.', error)
            return error.response.data
        }
    },

    findImages: async (data) => {
        const url = `${BASE_URL}/api/find-images`
        try {
            const response = await axios.post(url, data);
            return response.data
        } catch (error) {
            // Handle network errors
            console.log('Error', 'An error occurred. Please try again later.', error)
            return error.response.data
        }
    }
}